<div class="modal-header" translate>Could not contact ELEMENTS Client</div>
<div class="modal-body">
  <p translate>The ELEMENTS Client app does not appear to be running on your machine.</p>
  <div class="image">
    <img src="/assets/client.png" [alt]="'ELEMENTS Client' | translate" />
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-outline-primary" (click)="complete(true)">Retry</button>
</div>
